import React from 'react';
import { Link } from 'react-router-dom';
import { SignupForm } from '../components/';
import OAuthButton from '../components/OAuthButton';
import { handleLoginWithGoogle } from '../authActions';

const Signup: React.FC = () => {
  return (
    <>
      <SignupForm />
      <p className="text-center text-sm/6 text-gray-500 mt-4">
        Already have an account?{' '}
        <Link
          to="/auth/login"
          className="font-semibold text-primary hover:text-secondary"
        >
          Login
        </Link>
      </p>
      <div className="relative my-4">
        <div aria-hidden="true" className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex justify-center text-sm/6 font-medium">
          <span className="bg-white px-6 text-gray-900">Or continue with</span>
        </div>
      </div>
      <OAuthButton
        provider="google"
        id="google-auth"
        onClick={handleLoginWithGoogle}
      />
    </>
  );
};

export default Signup;
